import React, { FC } from 'react';
import styled from 'styled-components';

import { WithChildren } from '@investown/fe/common-utils';

import SeedStarter from 'components/Logo/SeedStarter';

interface Props extends WithChildren {
  showSeedStarterLogo: boolean;
}

const RightSideCentered: FC<Props> = ({ children, showSeedStarterLogo }) => (
  <Container>
    {children}
    {showSeedStarterLogo && (
      <SeedStarterContainer>
        <SeedStarter />
      </SeedStarterContainer>
    )}
  </Container>
);

const Container = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  position: relative;
  justify-content: center;
  align-items: center;
`;

const SeedStarterContainer = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  left: 0;
  right: 0;
  bottom: ${({ theme }) => theme.margins.huge};
`;

export default RightSideCentered;
